import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-before-workorder-modal2',
  templateUrl: './before-workorder-modal2.component.html',
  styleUrls: ['./before-workorder-modal2.component.scss'],
})
export class BeforeWorkorderModal2Component {
  constructor(private modalRef: MatDialogRef<BeforeWorkorderModal2Component>) {}

  close() {
    this.modalRef.close(true);
  }
}
